// extracted by mini-css-extract-plugin
export default {"banner":"cWKB6","banner__text":"re0QV","banner__social":"qJ6pz","social-button":"r91qB","banner__buttons":"h4Sh8","banner__qr-code-link":"hvAHm"};